export const AppointmentLabelConstants={
    Appointment:'Appointment',
    AppointmentType:'Appointment Type',
    Accepted:'Accepted',
    Approved:'Approved',
    Address:'Address',
    Accept:'Accept',
    Amount:'Amount',
    Approve:'Approve',
    AppointmentConfirmation:'Appointment Confirmation',
    AreYouSureReject:'Are you sure you want to Reject',
    AppointmentApproved:'Appointment Approved Succesfully',
    Actions:'Actions',
    AppointmentDate:'Appointment Date',
    CustomerName:'Customer Name',
    City:'City',
    Country:'Country',
    Cancel:'Cancel',
    Date:'Date',
    Email:'Email',
    Filter:'Filter',
    Link:'Link',
    Message:'Message',
    NoRecordFound:'No any appointment records found!',
    OrderDate:'Order Date',
    Pending:'Pending',
    Rejected:'Rejected',
    Status:'Status',
    Sure:'Sure',
    State:'State',
    Reject:'Reject',
    ReasonReject:'Reason For Rejection',
    Phone:'Phone',
    Time:'Time',
    ZipCode:'Zip Code',
}

export const CouponLabelConstants = {
    Actions: 'Actions',
    Add: 'Add',
    AddNew: 'Add New',
    AutoGenerate: 'Auto Generate',
    Cancel: 'Cancel',
    CouponCode: 'Coupon Code',
    CouponType: 'Coupon Type',
    Special:'Special',
    General:'General',
    Discount: 'Discount',
    DiscountType: 'Discount Type',
    EndDate: 'End Date',
    ExpireDate: 'Expire Date',
    Filter: 'Filter',
    Flat: 'Flat',
    NoRecordFound: 'No any coupon code records found!',
    Percentage: 'Percentage',
    Reward:'Reward',
    SrNo: '#',
    StartDate: 'Start Date',
    TotalParticipants: 'Total Participants',
    Update: 'Update',
    CouponDescription : 'Coupon Description'
};

export const CustomerLabelConstants = {
    Actions: 'Actions',
    Address: 'Address',
    AddNew: 'Add New',
    Add: 'Add',
    Cancel: 'Cancel',
    City: 'City',
    Country: 'Country',
    Email: 'Email',
    Filter: 'Filter',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Name: 'Name',
    PhoneNumber: 'Phone Number',
    PostalCode: 'Postal Code',
    State: 'State',
    Update: 'Update',
    EventAttended:'Event Attended',
    SessionAttended:'Session Attended',
    CustomerList: 'Customer Management',
    NoRecordFound:'No any customer records found!'
};

export const commonLabelConstants ={
    ChangeStatus:'Change Status',
    AreYouSure:'Are you sure you want to',
    Yes:'Yes',
    No:'No',
    Logout:'Logout',
    Cancel:'Cancel',
    Delete:'Delete',
    UnsavedChanges:'You have unsaved changes . Are You Sure? ',
    CopyRight:'Copyright',
    Rights:'All rights reserved.',
    MyAccount:'My Account'

}

export const EventLabelConstants = {
    Actions: 'Actions',
    Add: 'Add',
    AddLocation: 'Add Location',
    AddNew: 'Add New',
    Address: 'Address',
    Cancel: 'Cancel',
    City: 'City',
    Contact: 'Contact Number',
    Country: 'Country',
    DateRange: 'Date Range',
    TimeRange: 'Event Time',
    Event: 'Event',
    EventAddress: 'Event Address',
    EventDates: 'Event Dates',
    EventDetails: 'Event Details',
    EventFees: 'Event Fees',
    EventName: 'Event Name',
    EventQandA: 'Event Question And Answers',
    EventTime: 'Event Time',
    Fees: 'Fees',
    Filter: 'Filter',
    HostedBy: 'Hosted By',
    NoImageSelected: 'No images selected',
    NoOfParticipants: 'Max. No. Of Participants',
    NoQuestions: 'No questions selected yet.',
    NoRecordFound: 'No any event records Found!',
    NoOptions: 'No options available.',
    Participants: 'Participants',
    QuestionName: 'Question Name',
    QuestionType: 'Question Type',
    RemoveImage: 'Remove Image',
    SelectAll: 'Select All',
    SelectQuestion: 'Select The Questions You Like.',
    SrNo: '#',
    State: 'State',
    UploadGalleryImages: 'Upload Gallery Images',
    UploadImage: 'Upload Event Image',
    Update: 'Update',
    ZipCode: 'Zip Code',
};

export const EventQuestionConstants={
    Option:'Option',
    QuestionType:'Question Type',
    QuestionText:'Question Text'
}

export const ForgotPassLabelConstants = {
    BackToLogin: 'Back To Login',
    Email: 'Enter Your E-mail*',
    ForgotPassword: 'Forgot Password',
    GoBack: 'GO TO BACK',
    ResetPassword: 'Reset Password',
    SendLink: 'Send Reset Link On Email',
};

export const EventQuestionLabels ={
    FormBuilder:'Form Builder',
    Filter:'Filter',
    AddNew:'Add New',
    SrNo:'#',
    Question:'Question',
    QuestionType:'Question Type',
    Actions:'Actions',
    NoRecordFound:'No any question record found!'
}

export const LoginLabelConstants = {
    Email: 'Email address',
    ForgotPass: 'Forgot Password?',
    Login: 'Login',
    Password: 'Password',
};

export const MyAccountLabelConstants = {
    Address: 'Address',
    ChangePassword: 'Change Password',
    City: 'City',
    ConfirmPassword: 'Confirm Password',
    Country: 'Country',
    Email: 'Email',
    FirstName: 'First Name',
    LastName: 'Last Name',
    MyAccount: 'My Account',
    NewPassword:'New Password',
    OldPassword:'Old Password',
    PhoneNumber: 'Phone Number',
    PostalCode: 'Postal Code',
    State: 'State',
    UpdateProfile: ' Update Profile',
    UserProfile:'User Profile'
};

export const PaymentDetailLabelConstants = {
    Actions: 'Actions',
    Add: 'Add',
    AddNew: 'Add New',
    Amount: 'Amount',
    DiscountType: 'Discount Type',
    ExpiryDays: 'Expiry Days',
    Filter: 'Filter',
    Limited:'Limited',
    NoOfPass: 'No Of Pass',
    NoDeleteRecordFound:'No any deleted pass record found!',
    PassName: 'Pass Name',
    Payment: 'Payment',
    PassType:'Pass Type',
    SrNo: '#',
    Text: 'Pass Description',
    Update: 'Update',
    Unlimited:'Unlimited',
    Cancel:'Cancel'
};

export const ResetPassLabelConstants = {
    ConfirmPassword: 'Confirm Password',
    GoBack: 'GO TO BACK',
    NewPassword: 'New Password',
    Password: 'Password',
    ResetPassword: 'Reset Password',
};

export const RewardCouponConstants = {
    Coupon: 'Coupon',
    Customer: 'Customer',
    Discount: 'Discount',
    ExpireDate: 'Expire Date',
    Filter: 'Filter',
    NoRecordFound: 'No any rewarded customer record found!',
    RewardedCoupon: 'Rewarded Coupons',
    SrNo: '#',
    StartDate: 'Start Date',
};

export const RoleLabelConstants = {
    Actions: 'Actions',
    Add: 'Add',
    AddNew: 'Add New',
    Cancel: 'Cancel',
    RoleManagement: 'Role Management',
    RoleName: 'Name of Role',
    NoRecordFound:'No any role record found!',
    Srno: '#',
    TypeRoleName: 'Role Name',
    Update: 'Update'

};

export const SettingLabelConstants ={
    Update:'Update',
    Cancel:'Cancel',
    AddContent:'Add Content',
    AddButton:'Add 15 Minutes Video Call',
    NoRecordFoundAboutSection:' No any about content record found!',
    AddContentImage:'Add Content Images',
    AddTestimonial:'Add Testimonial',
    NoRecordFoundTestimonial:"No any testimonials record found!",

    // About Image Dialog Constants
    AboutImages:'About Images',
    UploadAboutImage:'Upload About Images',
    DragDrop:'Drag and drop your files hear',
    FileSupported:'File supported: .JPG, .PNG',
    Or:'- or -',
    Browsefiles:'Browse files',
    NoImageSelected:'No Images Selected',
    Upload:'Upload',
    ImagePreview:'Uploaded Image Preview:',
    NoImageUploaded:'No any image upload yet!',
    Add:'Add',

    // About Section Form Dialog Constants
    ImageAlignment:'Image Alignment',
    AddActionButton:'Add Action Button',
    AddCall:' Add 15 Minutes Video Call',
    ContentTitle:'Content Title',
    UploadImage:'Upload Image',
    Content:'Content',

    // Testimonial Form Dialog Constants
    TestimonialContent:'Testimonial Content',
    PersonName:'Person Name'

}

export const UserLabelConstants = {
    Actions: 'Actions',
    Add: 'Add',
    AddNew: 'Add New',
    Address: 'Address',
    Cancel: 'Cancel',
    City: 'City',
    Country: 'Country',
    Email: 'Email',
    FirstName: 'First Name',
    Filter: 'Filter',
    Image: 'Image',
    LastName: 'Last Name',
    NameOfRole: 'Name Of Role',
    NoRecordFound:'No any user record found!',
    PhoneNumber: 'Phone Number',
    PostalCode: 'Postal Code',
    Role: 'Role',
    State: 'State',
    Update: 'Update',
    UserManagement: 'User Management',
};

export const ReportStatusConstants = {
    Okay: 'Okay',
    ApporovedStatus: 'Your approval message send to this user successfully.',
    RejectedStatus: 'Your reject message send to this user successfully.',
};

export const ResendEmailConfirmationConstants ={
    RequestEmail:'Request Email',
    AreYouSure:'Are you sure you want to resend a payment request link again?',
    Send:'Send'
}